import { useMutation, useQueryClient } from '@tanstack/react-query'
import { accountKeys, MODE } from '../../../data/queryFactories'
import AccountForm from './AccountForm'
import { useNav } from '../../../hooks/useNav'
import { showErrorToast, showSuccessToast } from '../../../utils/showToast'
import { accountService } from '../../../service/AccountService'
import { PATH } from '../../../data/router_path'

export default function CreateAccountPopUp({ closePopUp }) {
  const queryClient = useQueryClient()

  const createAccountMutation = useMutation({
    mutationFn: async (account) => {
      if (account.schoolId.length < 8) {
        const message = 'Mã số sinh viên phải có ít nhất 8 ký tự!'
        throw new Error(message)
      }
      const { success, message } = await accountService.create({
        bulk: Array.isArray(account),
        payload: {
          ...account,
          schoolUuid: '8d65a001-e733-4ed8-89ef-3eafc1fc09e3',
          facultyUuid: '87792a91-ca6d-4f14-8399-7216eec15b80',
        },
      })

      if (!success) {
        throw new Error(message.content)
      }

      return { success, message }
    },
    onError: (error) => {
      showErrorToast({
        message: error.message || 'Tạo tài khoản thất bại',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accountKeys.all })
      showSuccessToast('Tạo tài khoản thành công')
      closePopUp()
    },
  })

  return (
    <AccountForm
      mode={MODE.CREATE}
      initForm={{
        schoolId: '',
        fullName: '',
        studentCourse: '',
        groupUuids: [],
        personalEmail: '',
        schoolEmail: '',
        phoneNumber: '',
        className: '',
        faculty: '',
        school: '',
      }}
      submitHandler={(formData) => {
        createAccountMutation.mutate(formData)
      }}
      closePopUp={closePopUp}
    />
  )
}
